// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Admin__AdminsFormController from "./admin/admins_form_controller"
application.register("admin--admins-form", Admin__AdminsFormController)

import Admin__CompaniesFormController from "./admin/companies_form_controller"
application.register("admin--companies-form", Admin__CompaniesFormController)

import Attandances__ClockController from "./attandances/clock_controller"
application.register("attandances--clock", Attandances__ClockController)

import Attandances__ConfirmController from "./attandances/confirm_controller"
application.register("attandances--confirm", Attandances__ConfirmController)

import Attandances__ModeToggleController from "./attandances/mode_toggle_controller"
application.register("attandances--mode-toggle", Attandances__ModeToggleController)

import Attandances__WorkEditController from "./attandances/work_edit_controller"
application.register("attandances--work-edit", Attandances__WorkEditController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PersonalAttendances__FilterAttendanceController from "./personal_attendances/filter_attendance_controller"
application.register("personal-attendances--filter-attendance", PersonalAttendances__FilterAttendanceController)

import PersonalAttendances__TableController from "./personal_attendances/table_controller"
application.register("personal-attendances--table", PersonalAttendances__TableController)

import Projects__ClearFilterController from "./projects/clear_filter_controller"
application.register("projects--clear-filter", Projects__ClearFilterController)

import Projects__ExpandController from "./projects/expand_controller"
application.register("projects--expand", Projects__ExpandController)

import Projects__ModalController from "./projects/modal_controller"
application.register("projects--modal", Projects__ModalController)

import Team__BulkCreationController from "./team/bulk_creation_controller"
application.register("team--bulk-creation", Team__BulkCreationController)

import Team__SearchController from "./team/search_controller"
application.register("team--search", Team__SearchController)

import TeamBulkFormController from "./team_bulk_form_controller"
application.register("team-bulk-form", TeamBulkFormController)

import Tools__FormController from "./tools/form_controller"
application.register("tools--form", Tools__FormController)

import Tools__SearchController from "./tools/search_controller"
application.register("tools--search", Tools__SearchController)

import Tools__TableController from "./tools/table_controller"
application.register("tools--table", Tools__TableController)

import Tools__WageController from "./tools/wage_controller"
application.register("tools--wage", Tools__WageController)

import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import WorkAssignments__ScheduleModalController from "./work_assignments/schedule_modal_controller"
application.register("work-assignments--schedule-modal", WorkAssignments__ScheduleModalController)

import WorkAssignments__WeekCalendarController from "./work_assignments/week_calendar_controller"
application.register("work-assignments--week-calendar", WorkAssignments__WeekCalendarController)

import WorkPerformances__ModeController from "./work_performances/mode_controller"
application.register("work-performances--mode", WorkPerformances__ModeController)

import WorkTypes__FormController from "./work_types/form_controller"
application.register("work-types--form", WorkTypes__FormController)

import WorkTypes__TableController from "./work_types/table_controller"
application.register("work-types--table", WorkTypes__TableController)

import Workers__WorkerController from "./workers/worker_controller"
application.register("workers--worker", Workers__WorkerController)
